// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"945":"dashboard","966":"login"}[chunkId] + "." + {"945":"9bd2e23d","966":"7e3615e5"}[chunkId] + ".js";
};